import { defineWave } from '../schema';

/** INTRO — six secondes sans aucun ennemi.
 *
 *  Le joueur découvre qu'il se déplace, que son tir est automatique, et que le
 *  décor défile. Rien d'autre. C'est le premier des cinq « beats »
 *  d'onboarding du plan (§6.12), et le seul qui n'a besoin d'aucun contenu.
 *
 *  Aucun texte, aucun pictogramme : le premier run EST le tutoriel. */
export default defineWave({
  id: 'intro',
  duration: 6,
  spawns: [],
});
